import { useContext, useEffect, useState } from "react";
import { GET_BUSINESS_BY_ID, fetchData } from "../../components/Service";
import {
  Link,
  useLocation,
  useParams,
} from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _ from "lodash";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";

const BusinessDetails = () => {
  const { business_id } = useParams();
  const location = useLocation();
  const [context] = useContext(Context);
  const [data, setData] = useState();

  const getDetails = (country_id, state_id, businessId) => {
    let payload = {
      country_id: country_id,
      state_id: location?.state?.state_id ?? state_id,
      business_list_id: businessId,
    };

    fetchData(GET_BUSINESS_BY_ID, "POST", payload, false, false, (res) => {
      if (res.status) {
        setData(res?.data);
      } else {
        setData();
      }
    });
  };

  useEffect(() => {
    scrollTop();
    if (context?.countryId && context?.stateId && business_id) {
      getDetails(context?.countryId, context?.stateId, business_id);
    }
  }, [context?.stateId, business_id]);

  const getDefaultPath = () => {
    if (data?.listing) {
      if (data.listing?.cat_id.slug === "temple") {
        if (data.listing?.sub_cat_id.slug === "hindu-temples") {
          return "/assets/images/business/hindu_temple.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "iskon-temple") {
          return "/assets/images/business/iskon-temple.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "gurudwara") {
          return "/assets/images/business/gurudwara.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "buddha-vihar") {
          return "/assets/images/business/buddha-vihar.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "churches") {
          return "/assets/images/business/churches.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "mosques-darga") {
          return "/assets/images/business/mosques-darga.jpeg";
        } else if (data.listing?.sub_cat_id.slug === "jain-temples") {
          return "/assets/images/business/jain-temples.jpeg";
        } else {
          return "/assets/images/business/temples.jpeg";
        }
      } else if (data.listing?.cat_id.slug === "restaurant") {
        if (data.listing?.sub_cat_id.slug === "indian-restaurants") {
          return "/assets/images/business/indian-restaurants.jpeg";
        } else {
          return "/assets/images/business/other-restaurants.jpeg";
        }
      } else if (data.listing?.cat_id.slug === "pub") {
        return "/assets/images/business/pub.jpeg";
      }
	  else if (data.listing?.cat_id.slug === "grocery-store") {
        return "/assets/images/business/grocery-store.jpeg";
      }
    } else {
      return "/assets/images/no-image.jpg";
    }
  };

  return (
    <>
      {data ? (
        <div className="col-lg-12">
          <div className="card card-forum">
            <div className="card-header usa-bg px-1">
              <div className="national-bg">
                <div className="row d-flex align-items-center ind1">
                  <div className="col-lg-12">
                    <h4 className="text-white d-flex mb-0 py-2">
                      {_.startCase(data?.listing?.name)}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body bg-white p-1">
              <div className="card p-1">
                <div className="card-header p-1">
                  <ul className="point-list">
                    <li>
                      <span>
                        <i className="fi fi-sr-eye"></i>
                      </span>
                      {data?.listing?.total_views}
                    </li>
                    <li>
                      <span>
                        <i className="fi fi-rr-calendar-lines"></i>
                      </span>{" "}
                      {data?.listing?.created_at
                        ? moment(data?.listing?.created_at).format(
                            "DD-MMM-YYYY"
                          )
                        : ""}
                    </li>
                    <li>
                      <span>
                        <i className="fi fi-rs-marker"></i>
                      </span>{" "}
                      {data?.listing?.location}
                    </li>
                  </ul>
                </div>
                <div className="row align-items-stretch">
                  <div className="col-xl-5">
                    <img
                      src={
                        data?.listing?.image
                          ? data?.listing?.image
                          : getDefaultPath()
                      }
                      className="img-fluid rounded-3"
                    />
                  </div>
                  <div className="col-xl-7">
                    <div className="card-body border h-100">
                      <h6 className="card-title">Overall Ratings:</h6>
                      <div className="row">
                        <div className="col-md-4 text-center">
                          <h1 className="display-4 mt-3">{data?.average_rating}</h1>
                          <div className="mb-3">
                            <i
                              className={`fi fi-sr-star mx-1 ${
                                data?.average_rating >= 5
                                  ? "text-warning"
                                  : "text-muted"
                              }`}
                            ></i>
                            <i
                              className={`fi fi-sr-star mx-1 ${
                                data?.average_rating >= 4
                                  ? "text-warning"
                                  : "text-muted"
                              }`}
                            ></i>
                            <i
                              className={`fi fi-sr-star mx-1 ${
                                data?.average_rating >= 3
                                  ? "text-warning"
                                  : "text-muted"
                              }`}
                            ></i>
                            <i
                              className={`fi fi-sr-star mx-1 ${
                                data?.average_rating >= 2
                                  ? "text-warning"
                                  : "text-muted"
                              }`}
                            ></i>
                            <i
                              className={`fi fi-sr-star mx-1 ${
                                data?.average_rating >= 1
                                  ? "text-warning"
                                  : "text-muted"
                              }`}
                            ></i>
                          </div>
                          <h6 className="text-muted">
                            Based on {data?.listing?.reviews?.length || "0"}{" "}
                            reviews
                          </h6>
                        </div>
                        <div className="col-md-8">
                          <div className="rating-bars">
                            <div className="rating-bar mb-1">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>5 stars</span>
                                <small className="text-muted">70%</small>
                              </div>
                              <div className="progress" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  role="progressbar"
                                  style={{ width: "70%" }}
                                  aria-valuenow="70"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div className="rating-bar mb-1">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>4 stars</span>
                                <small className="text-muted">20%</small>
                              </div>
                              <div className="progress" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  role="progressbar"
                                  style={{ width: "40%" }}
                                  aria-valuenow="20"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div className="rating-bar mb-1">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>3 stars</span>
                                <small className="text-muted">5%</small>
                              </div>
                              <div className="progress" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  role="progressbar"
                                  style={{ width: "30%" }}
                                  aria-valuenow="30"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div className="rating-bar mb-1">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>2 stars</span>
                                <small className="text-muted">3%</small>
                              </div>
                              <div className="progress" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  role="progressbar"
                                  style={{ width: "15%" }}
                                  aria-valuenow="15"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div className="rating-bar">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>1 star</span>
                                <small className="text-muted">2%</small>
                              </div>
                              <div className="progress" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  role="progressbar"
                                  style={{ width: "8%" }}
                                  aria-valuenow="8"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {data?.listing?.reviews &&
                    data?.listing?.reviews?.length > 0 && (
                      <div className="col-xl-12">
                        <div className="card-body border mt-1">
                          <h6 className="card-title mt-3 mb-0">Reviews:</h6>
                          <p className="mb-2">
                            {data?.listing?.reviews?.length} Reviews
                          </p>
                          <ul className="comments-list">
                            {data?.listing?.reviews?.map((item) => (
                              <li key={item.id}>
                                <span className="img-user">
                                  <img src="/assets/images/slide1-1480.jpg" />
                                </span>
                                <span>Unknown</span>
                                {/* <h6>
																{item?.user ? item?.user : "Unknown"}
																<span>{item?.created_at ? moment(item?.created_at).format("DD-MMM-YYYY hh:mm a") : ""}</span>
															</h6> */}
                                <p className="mb-1">{item?.comment}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  <div className="col-xl-6">
                    <div className="card-body border mt-1 h-100">
                      <h6>Specification:</h6>
                      <div className="table-responsive">
                        <table className="table table-borderless table-sm">
                        <tbody>
                          <tr>
                            <td style={{ width: "120px" }}>Name </td>
                            <td className="fw-bold">{data?.listing?.name}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "120px" }}>Contact Name </td>
                            <td className="fw-bold">
                              {data?.listing?.contact_name}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "120px" }}>Address </td>
                            <td className="fw-bold">
                              {data?.listing?.contact_address}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "120px" }}>Email </td>
                            <td className="fw-bold">
                              {data?.listing?.contact_email}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "120px" }}>Number </td>
                            <td className="fw-bold">
                              {data?.listing?.contact_number}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "120px" }}>Url </td>
                            <td className="fw-bold">
                              {data?.listing?.url ? (
                                <Link to={data?.listing?.url} target="_blank">
                                  {data?.listing?.url}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="card-body border mt-1 h-100">
                      <h6>Opening Hours:</h6>
                      <div className="table-responsive">
                        {Number(data?.listing?.business_hour?.is24) == 1 ? (
                          <table className="table table-borderless table-sm">
                            <tr>
                              <td style={{ width: "120px" }}>Open </td>
                              <td className="fw-bold">24/7</td>
                            </tr>
                          </table>
                        ) : (
                          <table className="table table-borderless table-sm">
                            <tr>
                              <td style={{ width: "120px" }}>Sunday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.sun_open &&
                                data?.listing?.business_hour?.sun_close
                                  ? `${data?.listing?.business_hour?.sun_open} - ${data?.listing?.business_hour?.sun_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Monday Name </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.mon_open &&
                                data?.listing?.business_hour?.mon_close
                                  ? `${data?.listing?.business_hour?.mon_open} - ${data?.listing?.business_hour?.mon_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Tuesday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.tue_open &&
                                data?.listing?.business_hour?.tue_close
                                  ? `${data?.listing?.business_hour?.tue_open} - ${data?.listing?.business_hour?.tue_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Wednesday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.wed_open &&
                                data?.listing?.business_hour?.wed_close
                                  ? `${data?.listing?.business_hour?.wed_open} - ${data?.listing?.business_hour?.wed_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Thursday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.thu_open &&
                                data?.listing?.business_hour?.thu_close
                                  ? `${data?.listing?.business_hour?.thu_open} - ${data?.listing?.business_hour?.thu_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Friday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.fri_open &&
                                data?.listing?.business_hour?.fri_close
                                  ? `${data?.listing?.business_hour?.fri_open} - ${data?.listing?.business_hour?.fri_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "120px" }}>Saturday </td>
                              <td className="fw-bold">
                                {data?.listing?.business_hour?.sat_open &&
                                data?.listing?.business_hour?.sat_close
                                  ? `${data?.listing?.business_hour?.sat_open} - ${data?.listing?.business_hour?.sat_close}`
                                  : "Closed"}
                              </td>
                            </tr>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-12">
								<div className="card-body h-100">
									<h6>Nearby views:</h6>
								</div>
							</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-lg-12">
          <div className="card card-forum ">
            <div className="card-body bg-white p-1">
              <div className="text-center text-danger p-3">No Records Found!</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BusinessDetails;
